import { Button, Card } from "antd";
import useCreate from "hooks/useCreate";

const ConvertToMasterIssue = ({ master_issue_id, refetch }) => {
  const { is_saving, create: convertToMasterIssue } = useCreate({
    path: "/issue_groups",
    onSuccess: refetch,
    success_message: "Zmieniono na zgłoszenie zbiorcze",
  });

  return (
    <Card
      styles={{
        body: {
          display: "none",
        },
        header: {
          border: "none",
        },
      }}
      style={{ marginBottom: 24 }}
      title="Podzgłoszenia"
      extra={
        <Button
          loading={is_saving}
          type="primary"
          onClick={() => convertToMasterIssue({ master_issue_id })}
        >
          Zamień na zgłoszenie zbiorcze
        </Button>
      }
    />
  );
};

export default ConvertToMasterIssue;
